import { render, staticRenderFns } from "./StrutturePresidiListComponent.vue?vue&type=template&id=1a95a6f5"
import script from "./StrutturePresidiListComponent.vue?vue&type=script&lang=js"
export * from "./StrutturePresidiListComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports